"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const command_1 = require("../../type/command");
const createEnrolment_1 = tslib_1.__importDefault(require("./createEnrolment"));
const updateEnrolment_1 = tslib_1.__importDefault(require("./updateEnrolment"));
function createOrUpdateEnrolment(command, content, enrolment, user) {
    if (enrolment) {
        return updateEnrolment_1.default(command, content, enrolment);
    }
    else if (command.type === command_1.CommandType.ASSIGN_CONTENT) {
        // only create if type is assign content
        return createEnrolment_1.default(command, content, user);
    }
    return enrolment;
}
exports.createOrUpdateEnrolment = createOrUpdateEnrolment;
//# sourceMappingURL=index.js.map